module.exports = __webpack_public_path__ + "static/img/s3.1748213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s3.png
// module id = ODqb
// module chunks = 1